import type {EventDay} from "../entities/EventDay";
import {myAxios} from "../util/myAxios";
import {eventUrl} from './base';

export function getEventDay(
  dayId: string
): Promise<EventDay> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/days/${dayId}`)))
    .then(response => response.data);
}

export function getNextEventDayWithContest() : Promise<EventDay> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/days/next-with-contest`)))
    .then(response => response.data);
}

export function getNextEventDayWithGreeting() : Promise<EventDay> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/days/next-with-greeting`)))
    .then(response => response.data);
}
